<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch("updateWindowWidth", event.currentTarget.innerWidth);
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });

    this.$store.dispatch("updateWindowWidth", window.innerWidth);

    setTimeout(() => {
      this.$EventBus.$emit("userChanged");
    }, 100);

    this.$EventBus.$on("userChanged", () => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      if (userId && token) {
        window.Echo.connector.options.auth.headers['Authorization'] = `Bearer ${token}`
        window.Echo.options.auth = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        window.Echo.leave(`mobile.${userId}`)
        window.Echo.private(`mobile.${userId}`).listen(
          "MobileUpdate",
          (payload) => {
            if (window.location.href.indexOf('checkout') === -1) {
              this.$notification.show((payload.alias || payload.device).replace(/(<([^>]+)>)/gi, ""), {
                body: payload.message.replace(/(<([^>]+)>)/gi, "")
              }, {})

              this.$vs.notify({
                time: 10000,
                title: payload.alias || payload.device,
                text: payload.message,
                iconPack: "feather",
                icon: "icon-smartphone",
                color: "primary",
                position: "top-center",
              });
            }
          }
        );
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
};
</script>
